import { getHistory, getHistoryTableGroups, getHistoryUserDeps } from '@/service/history-service';

const valuesToText = vals => {
    return Object.keys(vals)
        .map(key => `${key}: ${vals[key]}`)
        .join('\r\n');
};

const valuesToText2 = (oldVal, newVal) => {
    return Object.keys(oldVal)
        .map(key => `${key}: ${oldVal[key]} -> ${newVal[key]}`)
        .join('\r\n');
};

const changesToText = (oldVal, newVal) => {
    try {
        if (oldVal && newVal) {
            return valuesToText2(oldVal, newVal);
        } else if (oldVal) {
            return valuesToText(oldVal);
        } else {
            return valuesToText(newVal);
        }
    } catch (ex) {
        return JSON.stringify({
            err: ex.message,
            old: oldVal,
            new: newVal,
        });
    }
};

export default {
    state() {
        return {
            tabGroups: [],
            userDeps: [],
            history: [],
            conditions: {
                // beg: null,
                // who: null,
                // operation: "x",
                limit: 0,
                emp_id: 0,
                dep_id: 0,
                grp_id: 20,
                tab_id: 62,
                // ctx_tab_id: 17,
                // ctx_keys: ["800020895"]
            },
        };
    },

    getters: {
        getHistoryForGrid: state => () => {
            return state.history.map(item => {
                item.changes = changesToText(item.old_val, item.new_val);
                delete item.old_val;
                delete item.new_val;
                return item;
            });
        },
    },
    mutations: {
        setHistory(state, data) {
            state.history = data;
        },
        resetCondition(state) {
            state.conditions = {
                limit: 1000,
            };
        },
        setCondition(state, data) {
            // console.log(data);
            for (const key of Object.keys(data)) {
                if (data[key] === null) {
                    delete state.conditions[key];
                } else {
                    state.conditions[key] = data[key];
                }
            }
        },
        setHistoryTableGroups(state, data) {
            state.tabGroups = data;
        },
        setHistoryUserDeps(state, data) {
            state.userDeps = data;
        },
    },
    actions: {
        async loadHistory({ commit }, conditions) {
            // const conditions = state.conditions;
            const items = await getHistory(conditions);
            commit('setHistory', items);
        },
        async setCondition({ commit }, data) {
            commit('setCondition', data);
        },
        async loadHistoryTableGroups({ commit }) {
            const items = await getHistoryTableGroups();
            //console.log(payload);
            const data = [];
            for (const group of items) {
                const grp_id = `grp-${group.id}`;
                data.push({
                    id: grp_id,
                    name: group.name,
                    info: group.info,
                });
                if (group.tables) {
                    for (const tab of group.tables) {
                        const tab_id = `${grp_id}.tab-${tab.id}`;
                        data.push({
                            id: tab_id,
                            groupId: grp_id,
                            name: tab.name,
                            info: tab.info,
                        });
                    }
                }

                commit('setHistoryTableGroups', data);
            }
        },
        async loadHistoryUserDeps({ commit }) {
            //console.log(payload);
            const items = await getHistoryUserDeps('history./users-departments');
            commit('setHistoryUserDeps', items);
        },
    },
};
